"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _carousel = _interopRequireDefault(require("../components/carousel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Directed edge will add the recommened products to slider once loaded
 * ------------------------------------------------------------------------------
 *
 * @namespace DirectedEdge
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-directed-edge="container"]',
  id: 'directed-edge__slider'
};
/**
 * Instance globals.
 */

var relatedSlider = {};
/**
 * Defaults.
 */

var config = {
  cellSelector: '.directed-edge__product',
  freeScroll: true,
  freeScrollFriction: 0.1,
  pageDots: false,
  prevNextButtons: true
};
var observerConfig = {
  attributes: true,
  childList: true,
  subtree: true
};
/**
 * Create related products slider
 */

var _default = function _default() {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    container: document.querySelector(selectors.container)
  };
  /**
   * Initialise component.
   */

  function init() {
    setListener();
  }
  /**
   * Set listeners.
   */


  function setListener() {
    if (nodeSelectors.container) {
      // Start observing the target node for configured mutations
      var observer = new MutationObserver(callback);
      observer.observe(nodeSelectors.container, observerConfig);
    } else {
      return false;
    }
  } // Callback function to execute when mutations are observed


  function callback(mutationsList, observer) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var mutation = _step.value;

        if (mutation.type === 'childList') {
          createSlider();
          observer.disconnect();
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } // Create an observer instance linked to the callback function


  function createSlider() {
    var namespace = "#".concat(selectors.id);
    relatedSlider = new _carousel["default"](namespace, config);
    relatedSlider.init();
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;